import { IJsonQueryTerm } from '../../../../api-models/common/json_query';

export enum EKitchenStove {
  Gas = 'gas',
  Electric = 'electric',
}

export type TKitchenStoveTerm = { kitchen_stove?: IJsonQueryTerm<EKitchenStove> };
